// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1Bhoj","author":"Table_author__1aun3","authorImage":"Table_authorImage__1r3P6","unreadRow":"Table_unreadRow__327j0"};